import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";

// Eager metadata registration; the render component (GridLayoutWidgetTemplate)
// code-splits into its own tpl-gridlayout-widget chunk, loaded on demand when the widget renders.
registerCardTemplate({
    id: 'gridlayout-widget',
    name: 'Grid Layout Widget',
    description: 'This widget can be used to represent multiple boxes.',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-gridlayout-widget" */ "./GridLayoutWidgetTemplate")),
    icon: generateIconProp('boxes'),
    complexity: 'easy',
});
